/* MaquettesParis — couche de mouvement (v11) */
(() => {
  const d = document;
  const root = d.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const design = root.classList.contains('shopify-design-mode') || window.Shopify?.designMode;
  const fine = window.matchMedia('(pointer: fine) and (hover: hover)').matches;
  const still = reduce || design;

  /* ---------- 1. Rideau de transition entre les pages ---------- */
  const hideCurtain = () => {
    if (!root.classList.contains('mp-curtain-on') && !root.classList.contains('mp-curtain-in')) return;
    root.classList.remove('mp-curtain-on', 'mp-curtain-in');
    root.classList.add('mp-curtain-out');
    setTimeout(() => root.classList.remove('mp-curtain-out'), 900);
  };
  window.addEventListener('pageshow', () => requestAnimationFrame(() => setTimeout(hideCurtain, 80)));
  if (d.readyState !== 'loading') setTimeout(hideCurtain, 80);

  d.addEventListener('click', (e) => {
    if (still || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]');
    if (!a || a.hasAttribute('download') || a.getAttribute('role') === 'button' || a.hasAttribute('aria-controls')) return;
    if (a.target && a.target !== '_self') return;
    const raw = a.getAttribute('href') || '';
    if (raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:') || raw.startsWith('javascript:')) return;
    let url;
    try { url = new URL(a.href, location.href); } catch { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    if (a.closest('[data-no-curtain]')) return;
    e.preventDefault();
    try { sessionStorage.setItem('mp-nav', '1'); } catch {}
    root.classList.remove('mp-curtain-out');
    root.classList.add('mp-curtain-in');
    setTimeout(() => { location.href = url.href; }, 430);
  });

  /* ---------- 2. Barre de progression ---------- */
  const bar = d.querySelector('.mp-progress i');

  /* ---------- 3. Apparitions (sections + images) ---------- */
  const isHome = d.body.classList.contains('template-index');
  const observerOptions = { threshold: 0.08, rootMargin: '0px 0px -6% 0px' };
  let io = null;
  if (!still && 'IntersectionObserver' in window) {
    root.classList.add('mp-motion');
    io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add('mp-in');
        io.unobserve(en.target);
      });
    }, observerOptions);
  }
  const watch = (el) => { if (io) io.observe(el); else el.classList.add('mp-in'); };

  const prepare = (scope) => {
    if (!isHome) {
      scope.querySelectorAll('main .shopify-section').forEach((sec, i) => {
        if (i === 0 || sec.classList.contains('mp-sec') || sec.querySelector('.mp-reveal, .mpv11')) return;
        sec.classList.add('mp-sec');
        watch(sec);
      });
    }
    scope.querySelectorAll('main img').forEach((img) => {
      if (img.classList.contains('mp-img') || img.closest('[data-no-reveal], header, footer, dialog, cart-drawer, slideshow-component, .stage__obj, .mp-buybar')) return;
      const w = parseInt(img.getAttribute('width') || '0', 10);
      if (w && w < 160) return;
      img.classList.add('mp-img');
      watch(img);
    });
  };
  const start = () => prepare(d);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  d.addEventListener('shopify:section:load', (e) => prepare(e.target));

  /* ---------- 4. Parallaxe + récit au défilement ---------- */
  const parallax = () => Array.from(d.querySelectorAll('[data-mp-parallax]'));
  const scrollies = () => Array.from(d.querySelectorAll('[data-mp-scrolly]'));
  let ticking = false;
  const onScroll = () => {
    ticking = false;
    const vh = window.innerHeight;
    const max = d.documentElement.scrollHeight - vh;
    if (bar) bar.style.transform = `scaleX(${max > 0 ? Math.min(window.scrollY / max, 1) : 0})`;
    if (still) return;
    parallax().forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const f = parseFloat(el.dataset.mpParallax) || 0.12;
      const off = (r.top + r.height / 2 - vh / 2) * -f;
      el.style.transform = `translate3d(0, ${off.toFixed(1)}px, 0)`;
    });
    scrollies().forEach((sec) => {
      const r = sec.getBoundingClientRect();
      const total = sec.offsetHeight - vh;
      const p = Math.min(Math.max(-r.top / (total || 1), 0), 1);
      sec.style.setProperty('--p', p.toFixed(3));
      const steps = sec.querySelectorAll('[data-step]');
      const n = parseInt(sec.dataset.mpSteps || '3', 10);
      const active = Math.min(n - 1, Math.floor(p * n * 0.999));
      steps.forEach((s) => s.classList.toggle('is-active', parseInt(s.dataset.step, 10) === active));
    });
  };
  const requestTick = () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } };
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  requestTick();

  /* ---------- 5. Onde au clic ---------- */
  if (!still) {
    d.addEventListener('pointerdown', (e) => {
      const host = e.target.closest('.mpv11 .btn, .mp-buybar__btn, .button, button.shopify-payment-button__button');
      if (!host) return;
      host.classList.add('mp-ripple-host');
      const r = host.getBoundingClientRect();
      const size = Math.max(r.width, r.height) * 2.2;
      const s = d.createElement('span');
      s.className = 'mp-ripple';
      s.style.cssText = `width:${size}px;height:${size}px;left:${e.clientX - r.left - size / 2}px;top:${e.clientY - r.top - size / 2}px`;
      host.appendChild(s);
      setTimeout(() => s.remove(), 700);
    }, { passive: true });
  }

  /* ---------- 6. Curseur, boutons magnétiques, cartes en 3D (ordinateur) ---------- */
  if (!still && fine) {
    const cur = d.createElement('div');
    cur.className = 'mp-cursor';
    cur.setAttribute('aria-hidden', 'true');
    d.body.appendChild(cur);
    let x = 0, y = 0, cx = 0, cy = 0;
    const loop = () => {
      cx += (x - cx) * 0.2; cy += (y - cy) * 0.2;
      cur.style.transform = `translate3d(${cx.toFixed(1)}px, ${cy.toFixed(1)}px, 0)`;
      requestAnimationFrame(loop);
    };
    loop();
    d.addEventListener('pointermove', (e) => {
      x = e.clientX; y = e.clientY; cur.classList.add('is-on');
      cur.classList.toggle('is-link', !!e.target.closest('a, button, summary, [role="button"], input, select, label'));
    }, { passive: true });
    d.addEventListener('pointerleave', () => cur.classList.remove('is-on'));
    d.addEventListener('pointerdown', () => cur.classList.add('is-down'));
    d.addEventListener('pointerup', () => cur.classList.remove('is-down'));

    d.addEventListener('pointermove', (e) => {
      const btn = e.target.closest('.mpv11 .btn');
      d.querySelectorAll('.mpv11 .btn.is-mag').forEach((b) => { if (b !== btn) { b.classList.remove('is-mag'); b.style.translate = ''; } });
      if (btn) {
        const r = btn.getBoundingClientRect();
        const mx = (e.clientX - r.left - r.width / 2) * 0.18;
        const my = (e.clientY - r.top - r.height / 2) * 0.28;
        btn.classList.add('is-mag');
        btn.style.translate = `${mx.toFixed(1)}px ${my.toFixed(1)}px`;
      }
      const card = e.target.closest('[data-mp-tilt]');
      d.querySelectorAll('[data-mp-tilt].is-tilt').forEach((c) => { if (c !== card) { c.classList.remove('is-tilt'); c.style.transform = ''; } });
      if (card) {
        const r = card.getBoundingClientRect();
        const rx = ((e.clientY - r.top) / r.height - 0.5) * -7;
        const ry = ((e.clientX - r.left) / r.width - 0.5) * 9;
        card.classList.add('is-tilt');
        card.style.transform = `perspective(900px) rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg) translateY(-6px)`;
      }
    }, { passive: true });
  }

  /* ---------- 7. Barre d'achat collante (fiche produit) ---------- */
  const buybar = d.querySelector('[data-mp-buybar]');
  if (buybar) {
    const form = d.querySelector('main form[action*="/cart/add"]');
    const link = buybar.querySelector('[data-mp-buy]');
    const syncVariant = () => {
      const id = form?.querySelector('[name="id"]')?.value;
      if (link && id) link.href = `/cart/${id}:1`;
    };
    form?.addEventListener('change', syncVariant);
    link?.addEventListener('click', syncVariant);
    const target = form || d.querySelector('main h1');
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        buybar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(target);
    } else {
      buybar.classList.add('is-on');
    }
  }

  /* ---------- 8. Ajout au panier : l'image vole vers le panier ---------- */
  d.addEventListener('click', (e) => {
    const btn = e.target.closest('.add-to-cart-button, form[action*="/cart/add"] [name="add"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    const cart = d.querySelector('[data-testid="cart-drawer-trigger"]');
    if (!cart) return;
    if (navigator.vibrate) { try { navigator.vibrate(12); } catch (err) {} }
    const bump = () => { cart.classList.remove('mp-bump'); void cart.offsetWidth; cart.classList.add('mp-bump'); };
    if (still) { setTimeout(bump, 250); return; }
    const vh = window.innerHeight;
    const src = Array.from(d.querySelectorAll('main img')).find((im) => {
      const r = im.getBoundingClientRect();
      return r.width > 120 && r.bottom > 40 && r.top < vh - 40;
    });
    const a = src ? src.getBoundingClientRect() : btn.getBoundingClientRect();
    const b = cart.getBoundingClientRect();
    const size = Math.min(a.width, a.height, 220);
    const fly = d.createElement(src ? 'img' : 'div');
    if (src) fly.src = src.currentSrc || src.src; else fly.style.background = '#D6B36A';
    fly.className = 'mp-fly';
    fly.alt = '';
    fly.style.cssText += `left:${a.left + a.width / 2 - size / 2}px;top:${a.top + a.height / 2 - size / 2}px;width:${size}px;height:${size}px`;
    d.body.appendChild(fly);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const dx = b.left + b.width / 2 - (a.left + a.width / 2);
      const dy = b.top + b.height / 2 - (a.top + a.height / 2);
      fly.style.transform = `translate(${dx}px, ${dy}px) scale(${(24 / size).toFixed(3)}) rotate(-12deg)`;
      fly.style.opacity = '0.3';
      fly.style.borderRadius = '50%';
    }));
    setTimeout(() => { fly.remove(); bump(); }, 720);
  });
})();
